export default __webpack_public_path__ + "static/men2-946c04518ec55d7a839b032b4ac611dd.webp";